import { containsLettersRegex } from '@thd-olt-functional/utils/dist/constants/regex-constants';

export const deliveryMethodOptions = [
  {
    name: 'Email',
    value: 'Email'
  },
  {
    name: 'Postal Mail',
    value: 'Postal Mail'
  }
];

export const getMyInformationOption = 'Access My Information';
export const getMyInformationOptionVal = 'Get My Information';
export const deleteMyInformationOption = 'Delete My Information';
export const correctMyInformationOption = 'Correct My Information';
export const OptOutOfSaleOption = 'Opt Out of Sale and Sharing or Use for Targeted Advertising';
export const OptOutOfSaleOptionVal = 'Opt Out of Sale';
export const limitUseSpiOption = 'Limit the Use of My Sensitive Personal Information';
export const limitUseSpiOptionVal = 'Limit Use of My Sensitive Information';

export const lexisNexisStatus = {
  passed: 'passed',
  failed: 'failed',
  pending: 'pending'
};

export const cpraRequestTypeOptions = [
  {
    name: getMyInformationOption,
    value: getMyInformationOptionVal
  },
  {
    name: deleteMyInformationOption,
    value: deleteMyInformationOption
  },
  {
    name: OptOutOfSaleOption,
    value: OptOutOfSaleOptionVal
  },
  {
    name: limitUseSpiOption,
    value: limitUseSpiOptionVal
  },
  {
    name: correctMyInformationOption,
    value: correctMyInformationOption
  }
];

export const requestTypeOptions = [
  {
    name: getMyInformationOption,
    value: getMyInformationOptionVal
  },
  {
    name: deleteMyInformationOption,
    value: deleteMyInformationOption
  },
  {
    name: OptOutOfSaleOption,
    value: OptOutOfSaleOptionVal
  }
];

export const validate = (value, regex) => {
  return value ? !!value.match(regex) : false;
};

const invalidRequiredInputValues = ['NA', 'NOT AVAILABLE', 'N/A'];

export const validateRequiredInput = (input) => {
  return input != null && !invalidRequiredInputValues.includes(input.trim().toUpperCase());
};

export const cityValidation = (fieldValue) => validateRequiredInput(fieldValue)
  && validate(fieldValue, containsLettersRegex);

export const scrollToRef = (ref) => {
  if (ref.current) {
    ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

export const imageBaseUrl = 'https://assets.homedepot-static.com/images/v1';
